// src/constants/viewIds.js
// Single source of truth — matches your p360_dashboard_views table exactly

export const VIEW_IDS = {
  PROJECT_LEVEL:              0,   // "Project Level"
  SCHEME_DIVERSITY:           1,   // "Scheme Diversity"
  COMPARISON:                 2,   // "Comparison"
  PROJECT_MILESTONE:          3,   // "Project Milestone"
  SUMMARY_VIEW:               4,   // "Summary View"
  WORK_DONE_VIEW:             5,   // "WorkDone View"
  FUNNEL_VIEW:                6,   // "Funnel View"
  STATEWISE_STATISTICS:       7,   // "StateWise Statistics"
  WEEKWISE_ACHIEVEMENT:       8,   // "WeekWise Achievement"
  CITIZEN_ATTRIBUTES:         9,   // "Citizen Attributes"
  DIVERSITY_IN_SCHEMES:      10,   // "Diversity in Schemes"
  DOCUMENT_SCHEME_RATIO:     11,   // "Document/Scheme Ratio"
  SCHEME_RATIO_OVERVIEW:     12,   // "Scheme Ratio Overview"
  CITIZEN_STATEWISE_STATS:   13,   // "Citizen State Wise Statistics"
  ENTREPRENEUR_MSME_SUMMARY: 14,   // "Entrepreneur/Msme Summary"
  TOP_BOTTOM_PERFORMANCE:    15,   // "Top/Bottom Performerance View"
  TOP_BOTTOM_PERFORMANCE_HD: 16,   // "Top/Bottom Peformance HD View"
  HD_PERFORMANCE_VIEW:       17,   // "HD Peformance View"
  DFL_CAMPS_SUMMARY:         18,   // "DFL Camps Summary"
  SCHEME_WISE_STATISTICS:    19,   // "Scheme Wise Statistics"
  CASE_REPORT:               20,   // "Case Report"
};

// Reverse map — id → name (useful for debugging)
export const VIEW_NAMES = Object.fromEntries(
  Object.entries(VIEW_IDS).map(([k, v]) => [v, k])
);